import React from 'react';

export default function Progress(props) {
  return (
    <div className="progress">
      <div className="filler" style={{ width: `${props.percentage}%`}}></div>
    </div>
  );
}